import { CertifiedSite } from '../types';

// 보증업체 (임시 데이터)
export const mockCertifiedSites: CertifiedSite[] = [
  {
    id: 1,
    name: '돛단배',
    description: '00년 무사고 메이저사이트',
    imageUrl: '/images/sites/Banner_1.png',
    tags: ['보증금', '00억'],
    url: '/WEVENT'
  },
  {
    id: 2,
    name: '대빵',
    description: '신규가입 00만 지급',
    imageUrl: '/images/sites/Banner_2.png',
    tags: ['보증금', '00억'],
    url: '/EEVENT'
  },
  {
    id: 3,
    name: '크크벳',
    description: '해외정식 라이센스 보유',
    imageUrl: '/images/sites/Banner_3.png',
    tags: ['보증금', '000억'],
    url: '/REVENT'
  },
  {
    id: 4,
    name: '이태리',
    description: '충전 00% 보너스',
    imageUrl: '/images/sites/Banner_4.png',
    tags: ['보증금', '00억'],
    url: '/TEVENT'
  },
  {
    id: 5,
    name: '펩시접속',
    description: '24시간 고객응대',
    imageUrl: '/images/sites/Banner_5.png',
    tags: ['보증금', '00억'],
    url: '/YEVENT'
  },
  {
    id: 6,
    name: '정글접속',
    description: '첫충 00% 이벤트',
    imageUrl: '/images/sites/Banner_6.png',
    tags: ['보증금', '00억'],
    url: '/UEVENT'
  },
  {
    id: 7,
    name: '에이피',
    description: '다양한 미니게임 제공',
    imageUrl: '/images/sites/Banner_7.png',
    tags: ['보증금', '00억'],
    url: '/IEVENT'
  },
  {
    id: 8,
    name: '벳마트',
    description: '해외 라이선스 보유',
    imageUrl: '/images/sites/Banner_8.png',
    tags: ['보증금', '00억'],
    url: '/OEVENT'
  },
  {
    id: 9,
    name: '당근접속',
    description: '해외 라이선스 보유',
    imageUrl: '/images/sites/Banner_9.png',
    tags: ['보증금', '00억'],
    url: '/PEVENT'
  },
  {
    id: 10,
    name: '에그에그',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_10.png',  
    tags: ['보증금', '00억'],
    url: '/AEVENT'
  },
  {
    id: 11,
    name: '썬뱃',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_11.png',  
    tags: ['보증금', '00억'],
    url: '/SEVENT'
  },
  {
    id: 12,
    name: '야옹이',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_12.png',  
    tags: ['보증금', '00억'],
    url: '/DEVENT'
  },
  {
    id: 13,
    name: '반딧불',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_13.png',  
    tags: ['보증금', '00억'],
    url: '/FVENT'
  },
  {
    id: 14,
    name: '땅콩접속',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_14.png',  
    tags: ['보증금', '00억'],
    url: '/GVENT'
  },
  {
    id: 15,
    name: '허슬러접속',
    description: '해외 라이선스 보유',  
    imageUrl: '/images/sites/Banner_15.png',  
    tags: ['보증금', '00억'],
    url: '/HVENT'
  }
]; 